module.exports = __webpack_public_path__ + "img/fangxing.76380148.png";